import React, { forwardRef } from 'react';
import styles from './input.module.css';


const KeyInput = forwardRef(({className, ...props},ref) => {
        return (
            <input {...props} ref={ref} className={`${styles.KeyInput} ${className}`} />
        )
})

export default KeyInput;